export default __webpack_public_path__ + "static/media/logo.6a93e971.svg";